var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class MemCacheUtil {
    /**
     * Get a string from the mem cache or generate it if it's not there or expired.
     *
     * ttl is in ms
     */
    static getOrGenString(_a) {
        return __awaiter(this, arguments, void 0, function* ({ key, ttl, generate, }) {
            return MemCacheUtil.getOrGen({
                key,
                ttl,
                generate,
                cache: MemCacheUtil.stringCache,
            });
        });
    }
    /**
     * Get a JsonBlob from the mem cache or generate it if it's not there or expired.
     *
     * ttl is in ms
     */
    static getOrGenJsonBlob(_a) {
        return __awaiter(this, arguments, void 0, function* ({ key, ttl, generate, }) {
            return MemCacheUtil.getOrGen({
                key,
                ttl,
                generate,
                cache: MemCacheUtil.jsonBlobCache,
            });
        });
    }
    /**
     * getOrGen is a helper function for getOrGenString and getOrGenJsonBlob.
     *
     * ttl is in ms
     */
    static getOrGen(_a) {
        return __awaiter(this, arguments, void 0, function* ({ key, ttl, generate, cache, }) {
            const record = cache[key];
            if (record && record.lastUpdated + record.ttl > Date.now()) {
                return record.data;
            }
            const data = yield generate();
            cache[key] = {
                data,
                lastUpdated: Date.now(),
                ttl,
            };
            return cache[key].data;
        });
    }
}
MemCacheUtil.stringCache = {};
MemCacheUtil.jsonBlobCache = {};
export default MemCacheUtil;
